export { default } from "/Users/einar/better.conflict/app/routes/index.tsx";